import React from "react";
import {Avatar, Box, Grid, makeStyles, Typography} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

import AppButton from "components/CustomButtons/AppButton";
import { Rating } from "@material-ui/lab";
import {useHistory} from "react-router-dom";
import {WORKER_TYPE} from "../../../../config/AppConfig";
import AppColor from "utilities/AppColor";

const styles = makeStyles(() => ({
  image: {
    width: '140px',
    height: '140px',
    borderRadius: '70px',
    objectFit: 'cover'
  },
  title: {
    fontSize: '28px',
    marginBottom: '20px'
  },
  specialty: {
    fontSize: '14px',
    fontWeight: 'bold'
  },
  container: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.18)'
  },
  description: {
    fontSize: 14,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-line-clamp': 2, /* number of lines to show */
    '-webkit-box-orient': 'vertical',
  },
  rating: {
    color: AppColor.mainColor
  }
}));

const ClientBookingUserTag = (props) => {
  const {
    userInfo,
    isAdmin
  } = props;
  const { t } = useTranslation();
  const history = useHistory();
  const classes = styles();

  const {
    // avatar,
    avatarAws3Link,
    firstName,
    lastName,
    distance = 0,
    accreditation,
    rating,
    description,
    id,
    workerType,
    specialties,
    supports,
    point
  } = userInfo;
  const name = `${firstName} ${lastName}`;

  const renderTagSearching = () => (
    <Box>
      <Typography variant="h5" className={classes.title}>
        {name}
      </Typography>
      <AppButton
          className='mr-1'
          label={`${t("label.viewProfile")}`}
          rounder
          buttonColor={AppColor.pink}
          onClick={() => navigateProfile()}
      />
      <Box mt={4}>
        {accreditation && (
            <Typography variant="body1" className={classes.specialty}>
              {accreditation.name}
            </Typography>
        )}
        <Typography variant="body1" className={classes.specialty} noWrap>
          {
            workerType === WORKER_TYPE.NURSE
                ? specialties && specialties.map(sp => sp.name).join(', ')
                : supports && supports.map(sp => sp.name).join(', ')
          }
        </Typography>
      </Box>
      <Box mt={3}>
        <Typography variant="body1" className={classes.description}>
          {description}
        </Typography>
      </Box>
    </Box>
  );

  const navigateProfile = () => {
    if (isAdmin) {
      history.push(`/admin/workers/${id}`);
    } else {
      history.push(`/search-worker/detail/${id}`);
    }
  };

  return (
      <Box my={3} py={3} className={classes.container}>
        <Grid container spacing={2}>
          <Grid item sm={12} md={2}>
            <Box display="flex" justifyContent="center">
              {avatarAws3Link ? (
                  <img src={avatarAws3Link} className={classes.image} alt="Avatar"/>
              ) : (
                  <Avatar style={{ width: '140px', height: '140px' }}/>
              )}
            </Box>
          </Grid>
          <Grid item sm={12} md={8}>
            {renderTagSearching()}
          </Grid>
          <Grid item sm={12} md={2}>
            <Box display="grid" className="h-100 text-right">
              <Box>
                <Rating
                    name="read-only"
                    value={rating || 0}
                    precision={0.5}
                    readOnly
                    className={classes.rating}
                />
                <Typography>
                  {t('label.point_value', {
                    value: point
                  })}
                </Typography>
              </Box>
              <Box mt={'auto'}>
                <Typography>
                  <i className="fas fa-map-marker-alt mr-2" />
                  {t('label.km_away', {
                    km: distance ? (distance / 1000).toFixed(2) : distance
                  })}
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
  );
}

ClientBookingUserTag.propTypes = {
  userInfo: PropTypes.object,
  isSchedule: PropTypes.bool,
  allowViewProfile: PropTypes.bool,
  isApplied: PropTypes.bool,
  isSearching: PropTypes.bool,
  isBooking: PropTypes.bool,
  isAdmin: PropTypes.bool,
  onAdd: PropTypes.func
};

export default ClientBookingUserTag;
